module.exports = __webpack_public_path__ + "img/1.22b2d80f.png";